var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19921 5.76398C6.15431 7.45056 3.34894 11.0812 2.23242 14.5332C3.86007 17.7885 10.2617 26.532 17.0619 32.8462C18.0172 33.7332 19.4834 33.7332 20.4386 32.8462C27.2388 26.5321 33.6405 17.7885 35.2681 14.5332C34.1516 11.0812 31.3463 7.45056 29.3013 5.76398C28.898 5.43131 28.3819 5.2832 27.8591 5.2832H9.64146C9.11863 5.2832 8.60255 5.43131 8.19921 5.76398Z",
    fill: "#84C70D",
    fillOpacity: 0.2,
    stroke: "#84C70D",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25293 14.5352H35.2577",
    stroke: "#84C70D",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49805 5.2832L18.748 14.5332L27.998 5.2832",
    stroke: "#84C70D",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.748 14.5352V34.3256",
    stroke: "#84C70D",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDiamond);
export default __webpack_public_path__ + "static/media/green-diamond.e74706c0b84465484f57de6d9d5bd078.svg";
export { ForwardRef as ReactComponent };